module.exports = __webpack_public_path__ + "img/box-skins-blue.f45f49ba.png";